module.exports = __webpack_public_path__ + "img/ico3.c7161cb5.png";